<template>
  <section id="mcKinsey-startup-accelerator">
    <br />
    <!-- <h5 class="is-size-5">
      Video Presentación para Demo Day Ceptinel - McKinsey Startup Accelerator
    </h5> -->
    <br />
    <figure class="image is-16by9">
      <iframe
        class="has-ratio"
        width="640"
        height="360"
        src="https://www.youtube.com/embed/D_JdhtsD-n8?showinfo=0"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </figure>
    <br />
  </section>
</template>
<script>
export default {
  name: "mcKinsey-startup-accelerator",
};
</script>
<i18n>
{
    "es": {
        "title": "Ceptinel y CAB (Compliance advisory Brazil) anuncian un nuevo partnership! CAB proporciona servicios de consultoría de compliance en Brazil y LATAM! Vamos a tener un excelente 2021!",
        "content": ""
    },
    "en": {
        "title": "Ceptinel and CAB (Compliance advisory Brazil) announce a new partnership! CAB provides compliance consulting services in Brazil and LATAM! We are going to have a great 2021!",
        "content": ""
    },
    "pt": {
        "title": "Ceptinel e CAB (Compliance Advisory Brasil) anunciam nova parceria! CAB fornece serviços de consultoria de compliance no Brasil e na América Latina! Vamos ter um ótimo 2021!",
        "content": ""
    }
}
</i18n>
